// Shared with the site graph, which lists this page last without its links and
// writes the page's Markdown.
export const sitemapMeta = {
  title: "Sitemap",
  description:
    "Every page on entire.com with its social card and last update, and a live map of how the pages link to each other.",
  url: "https://entire.com/sitemap",
  image: "https://entire.com/images/og/sitemap.png",
}

export const sitemapIntro =
  "Every page on entire.com with its social card and when it last changed. The lines trace how pages link to each other: hover or tap a card to follow its links. Only links in a page’s content count, not the header and footer every page shares."
